import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MdsModalService } from '@meddev/fe-shared';
import { DEFAULT_TOAST_SETTINGS } from '@shared/core';
import { AuthManagerPwaService } from '@shared/data';
import { filter, first, map, Observable, of, switchMap } from 'rxjs';

export const UserOnboardingStatusGuard = (): Observable<boolean> => {
    const authManager = inject(AuthManagerPwaService);
    const router = inject(Router);
    const mdsModalService = inject(MdsModalService);

    return authManager.userStatus$.pipe(
        filter(userStatus => userStatus !== undefined),
        first(),
        switchMap(userStatus => {
            if (!userStatus) {
                mdsModalService.showErrorModal(
                    $localize`User Status Error`,
                    $localize`Failed to retrieve user status. Please try again later.`,
                    DEFAULT_TOAST_SETTINGS,
                );
                return authManager.logout().pipe(map(() => false));
            }

            if (userStatus.termsAndConditions?.isAcceptanceRequired) {
                router.navigate(['/onboarding/terms-and-conditions']);
                return of(false);
            }
            if (userStatus.isEmailVerificationPending) {
                router.navigate(['/onboarding/email-confirmation-notice']);
                return of(false);
            }
            if (userStatus.isPolicyCreationNeeded || userStatus.requiresNewPlanSelection) {
                router.navigate(['/onboarding/insurance-plans']);
                return of(false);
            }
            if (userStatus.isPaymentMethodRequired || userStatus.requiresInitialPayment) {
                router.navigate(['/onboarding/payment']);
                return of(false);
            }
            return of(true);
        }),
    );
};
